import JSX from "../../helpers/react.js";
import {emojiCharacters} from "./_characters.js";
import RefObject = JSX.RefObject;


function placeElement(dialog: HTMLDivElement, clickEl: HTMLElement){
    const offset = $(clickEl).offset()!;
    let offsetRight = window.innerWidth - offset.left   - $(clickEl).width()!;
    let top = offset.top - window.scrollY;
    if(top < 400) top += 400+$(clickEl).height()!;
    console.log(top+"TOP");
    if(window.innerWidth <= 350) offsetRight = 5;
    dialog.style.right = offsetRight + "px";
    dialog.style.bottom = (window.innerHeight - top) + "px";
}
export function EmojisDialog({element, emojiEl}: {element: HTMLInputElement|HTMLDivElement, emojiEl: HTMLElement}){
    const dialog: RefObject = {};
    function onDocClick(e: { target: HTMLElement }){
        if(e.target.classList.contains('emojis-dialog') || (e.target.parentNode as HTMLElement)?.classList?.contains('emojis-dialog'))
            return;
        dialog.value!.remove();
        document.removeEventListener('click', onDocClick as any)
    }
    setTimeout(()=>{
        document.addEventListener('click', onDocClick as any);
    }, 0)
    const ans = (
        <div className="emojis-dialog bordered" ref={dialog}>
            {
                ...emojiCharacters.map(
                    emoji=><><span onClick={showEmoji.bind(emoji, element)}>{emoji}</span> </>
                )
            }
        </div>
    );
    document.addEventListener('scroll', onScroll)
    placeElement(ans, emojiEl);

    return ans;
    function onScroll(){
        if(!ans.parentElement) document.removeEventListener('scroll', onScroll);
        placeElement(ans, emojiEl);
    }
}

function showEmoji(this: string, el: HTMLInputElement|HTMLDivElement): any{
    // if('value' in (document.activeElement??{})){
    //     (document.activeElement as HTMLInputElement)!
    if(el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')
        (el as HTMLInputElement).value += this + " ";
    else {
        el.innerHTML += this + " ";
        el.focus({});
        placeCaretAtEnd(el);
    }
    $(el).trigger('input');
    // }
}
function placeCaretAtEnd(el: HTMLDivElement) {
    el.focus();
    if (typeof window.getSelection != "undefined"
        && typeof document.createRange != "undefined") {
        const range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        const sel = window.getSelection()!;
        sel.removeAllRanges();
        sel.addRange(range);
    }
    //@ts-ignore
    else if (typeof document.body.createTextRange != "undefined") {
        //@ts-ignore
        const textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
    }
}


$('html')
    .on('click','.emojis-btn', function(){
        const existingElement = document.body.querySelector(".emojis-dialog");
        if(existingElement) return existingElement.remove();
        document.body.appendChild(<EmojisDialog element={$(this).prev()[0]} emojiEl={this}/>);
    })